import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import back from '../assets/images/back_arrow.png';
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import Axios from 'axios';
import { message } from 'antd'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from "recharts";
import { useRecoilState } from 'recoil';
import { is_patient_custom_medical_data_updated } from '../Store/PatientProfileDetails'

    const moment = require('moment');
    const CustomEditVitals = () => {
    const location = useLocation();
    const [readingValue, setReadingValue] = useState("");
    const [buttonHide, setButtonHide] = useState(false);
    const today = new Date();
    const numberOfDaysToAdd = 0;
    const date1 = today.setDate(today.getDate() + numberOfDaysToAdd);
    const defaultValue = new Date(date1).toISOString().split('T')[0] // yyyy-mm-dd
    const [date, setDate] = useState(defaultValue);
    var hour = today.getHours();
    var min = today.getMinutes();
    hour = (hour < 10 ? "0" : "") + hour;
    min = (min < 10 ? "0" : "") + min;
    var displayTime = hour + ":" + min;
    const [time, setTime] = useState(displayTime);
    const [tableData, setTableData] = useState([]);
    const [trackingType, setTrackingType] = useState('');
    let pid = localStorage.getItem("patientid");
    const [inputColor, setInputColor] = useState('');
    const [error, setError] = useState("");
    const [isCustomMedicalTrackingDataUpdated, setIsCustomMedicalTrackingDataUpdated] = useRecoilState(is_patient_custom_medical_data_updated);
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
    };

    const backHandler = () => {
        global.OTPValidation = 'true';
        navigate(-1);
    }

    useEffect(() => {
        if (location.state) {
            if (location.state != '') {
                console.log(location.state);
                setTrackingType(location.state.tracking_name);
                Axios.get(`${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_custom_medical_tracking_data_by_trackingname?trackingname=${location.state.tracking_name}&patientid=${pid}&MDT=PM&user_role=rp`, { headers })
                    .then((response) => {
                        if (response.data.status == '1') {
                            console.log(response.data.data)
                            setTableData(response.data.data);
                        } else if (response.data.status == '401') {
                            console.log(response.data.data)
                            console.error("Unauthorized access. Logging out.");
                            message.error(response.data?.message || 'Unauthorized');
                            logoutHandler();
                        } else {
                            message.error('Unable to fetch data. Please try again later.');
                            setTableData([]);
                        }
                    }).catch((error) => {
                        if (error.response && error.response.status == '401') {
                            message.error(error.responseJSON.message || 'Unauthorized');
                            logoutHandler();
                        } else {
                            message.error('Unable to fetch data. Please try again later.');
                        }
                    });
            }
        }
    }, []);

    const navigate = useNavigate();

    const onReadingValueUpdate = (event) => {
        const value = Number(event.target.value); // Convert to a number
        if (isNaN(value) || value <= 0) {
            setError("Reading value cannot be zero or empty");
            setInputColor('red');
            setButtonHide(true);
        } else {
            setError(""); // Clear any errors
            setInputColor('green');
            setButtonHide(false);
        }
        setReadingValue(value); // Update the reading value
    }

    const handleChangeDate = (event) => {
        setDate(event.target.value);
    }

    const handleChangeTime = (event) => {
        setTime(event.target.value);
    }
    const updateHandeler = (e) => {
        setButtonHide(true);
        e.preventDefault();
        console.log("fgg")
        let formdata = $(e.target);
        formdata = new FormData();
        formdata.append('tracking_name', trackingType);
        formdata.append('patients_id_fk', pid);
        formdata.append('tracking_value', readingValue);
        formdata.append('tracking_datetime', date + " " + time);
        formdata.append('MDT', 'PM');
        formdata.append('user_role', 'rp');
        $.ajax({
            type: "POST",
            url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/add_custom_medical_tracking_data`,
            data: formdata,
            processData: false,
            contentType: false,
            headers: headers,
            success(data) {
                console.log("add successfully", data);
                Axios.get(`${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_custom_medical_tracking_data_by_trackingname?trackingname=${location.state.tracking_name}&patientid=${pid}&MDT=PM&user_role=rp`, { headers })
                    .then((response) => {
                        if (response.data.status == '1') {
                            console.log(response.data.data)
                            setTableData(response.data.data);
                            setButtonHide(false);
                            setIsCustomMedicalTrackingDataUpdated(true);
                        } else if (response.data.status == '401') {
                            message.error(error.response.data?.message || 'Unauthorized');
                            setTableData([]);
                            setButtonHide(false);
                            logoutHandler();
                        } else {
                            message.error('Unable to fetch data. Please try again later.');
                            setTableData([]);
                            setButtonHide(false);
                        }
                    }).catch((error) => {
                        if (error.response && error.response.status == '401') {
                            message.error(error.responseJSON.message || 'Unauthorized');
                            setButtonHide(false);
                            logoutHandler();
                        }
                    });
                setReadingValue('')
            },
            error: function (err) {
                if (err.status == '401') {
                    // Token expired, show message and log out
                    message.error(err.responseJSON.message || 'Unauthorized');
                    setButtonHide(false);
                    logoutHandler();
                } else {
                    console.error('Error occurred:', err.responseText);
                    setButtonHide(false);
                    message.error('Data upload failed. Please try again later.');
                }
            }
        });
    }

    const logoutHandler = () => {
        localStorage.removeItem("phoneNo");
        localStorage.removeItem("patientid");
        localStorage.removeItem("patientLocalImage");
        localStorage.removeItem("patientLocalData");
        localStorage.removeItem("patientUniqueId");
        localStorage.removeItem("chronic_illness_data");
        localStorage.removeItem("allergic_information_data");
        localStorage.removeItem("family_relation_data");
        localStorage.removeItem("family_disease_data");
        localStorage.removeItem("token");
        navigate("/Login");
    }

    const [showMore, setShowMore] = useState(false);
    const [showMoreGraph, setShowMoreGraph] = useState(false);

    const toggleShowMore = () => {
        setShowMore((prevState) => !prevState);
    };

    const toggleShowMoreGraph = () => {
        setShowMoreGraph((prevState) => !prevState);
    };



    return (
        <div>
            <header className="header">
                <img src={back} style={{ height: 20, width: 20 }} alt="back button" onClick={backHandler} />
                <h1 className="header-title"> Add Custom Medical Tracking</h1>
            </header>
            <>
                <div className="first-div">
                    <div>
                        <span
                            style={{
                                cursor: 'pointer',
                                color: '#007BFF',
                                textDecoration: 'underline',
                                fontSize: 12,
                            }}
                            onClick={toggleShowMore}
                        >
                            {showMore ? 'Show Less' : 'Show More'}
                        </span>
                    </div>
                    {showMore && (
                        <div
                            className="first-div"
                            style={{
                                marginTop: 5,
                                maxHeight: 200,
                                overflowY: 'scroll',
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}
                        >
                            <div style={{ marginTop: 5 }} className="medicineview">
                                <table
                                    id="prescriptiondata"
                                    style={{
                                        width: '100%',
                                        paddingRight: 5,
                                        borderRadius: 5,
                                        marginLeft: 5,
                                        marginRight: 5,
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: '50%', textAlign: 'center' }}>Reading</th>
                                            <th style={{ width: '50%', textAlign: 'center' }}>Date and Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData.length > 0 ? (
                                            tableData.map((val, index) => (
                                                <tr key={index}>
                                                    <td className="value" style={{ textAlign: 'center' }}>{val.tracking_value}</td>
                                                    <td className="value" style={{ textAlign: 'center' }}>
                                                        {moment(val.tracking_datetime).format('DD.MM.YYYY  HH:mm')}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={2}
                                                    className="label_style"
                                                    style={{
                                                        textAlign: 'center',
                                                        color: 'red',
                                                    }}
                                                >
                                                    No data found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
                {
                    tableData && tableData.length > 0 && (
                        <div className="first-div">
                            <div>
                                <span
                                    style={{
                                        cursor: 'pointer',
                                        color: '#007BFF',
                                        textDecoration: 'underline',
                                        fontSize: 12
                                    }}
                                    onClick={toggleShowMoreGraph}
                                >
                                    {showMoreGraph ? 'Show Less' : 'Show More'}
                                </span>
                            </div>
                            {showMoreGraph && (
                                <div className='first-div' >

                                    <LineChart
                                        width={310}
                                        height={300}
                                        data={tableData}
                                        margin={{
                                            top: 5,
                                            left: -30,
                                            bottom: 5
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="create_date" />
                                        <YAxis />
                                        <Tooltip />
                                        <Legend />
                                        <Line
                                            type="monotone"
                                            dataKey="Reading"
                                            stroke="#8884d8"
                                            activeDot={{ r: 8 }}
                                        />
                                    </LineChart>
                                </div>
                            )}
                        </div>
                    )
                }
                <div className='first-div' style={{ marginTop: 20, marginBottom: 40 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', padding: '0 20px' }}>
                        <p className="label_style" style={{ textAlign: 'left', fontSize: 12 }}>Add data for  </p>
                        <p className="label_style" style={{ color: 'black', fontSize: 12 }}>{trackingType}  </p>
                    </div>
                    <div style={{ padding: '0 20px', marginTop: 10 }} className="flex-div">
                        <div style={{ textAlign: 'left' }}>
                            <p className="label_style" style={{ fontSize: 12 }}> Reading Value:</p>
                        </div>
                        <div style={{ marginLeft: 15 }}>
                            <input
                                className="input_style"
                                style={{
                                    fontSize: 12,
                                    padding: '8px 12px',
                                    borderRadius: 4,
                                    width: 160,
                                    marginLeft: 10,
                                    color: inputColor,
                                }}
                                type="tel"
                                name="name"
                                required
                                value={readingValue}
                                maxLength={3}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) { // Regex to check for numbers only
                                        onReadingValueUpdate(e);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
                        {/* Date Input Section */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <label className="label_style" style={{ fontSize: 12, marginBottom: 5 }}>Date:</label>
                            <input
                                className="input_style"
                                type="date"
                                name="date"
                                value={date}
                                style={{
                                    fontSize: 12,
                                    padding: '8px 12px',
                                    borderRadius: 4,
                                    width: 140,
                                    marginTop: 5,
                                    marginLeft: 10
                                }}
                                onChange={(event) => handleChangeDate(event)}
                            />
                        </div>

                        {/* Time Input Section */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <label className="label_style" style={{ fontSize: 12, marginBottom: 5 }}>Time:</label>
                            <input
                                className="input_style"
                                type="time"
                                name="time"
                                value={time}
                                style={{
                                    fontSize: 12,
                                    padding: '8px 12px',
                                    borderRadius: 4,
                                    width: 140,
                                    marginTop: 5,
                                    marginLeft: 10
                                }}
                                onChange={(event) => handleChangeTime(event)}
                            />
                        </div>
                    </div>

                    {buttonHide === false ? (
                        <button
                            onClick={(event) => updateHandeler(event)}
                            type="submit"
                            style={{ marginTop: 30, width: 120 }}
                            className="btn btn-auto btn-primary"
                        >
                            Add
                        </button>
                    ) : (
                        setError.length > 0 ? (
                            <></>
                        ) : (
                            <p
                                style={{
                                    fontSize: 12,
                                    color: 'green',
                                    fontWeight: 'bold',
                                    marginTop: 15
                                }}
                            >
                                Updating...
                            </p>
                        )
                    )}
                    {(error) && (
                        <p style={{ color: 'red', fontSize: '12px', padding: 10 }}>{error}</p>
                    )}
                </div>
            </>
        </div>
    )
}

export default CustomEditVitals
